
import deepPurple from '@material-ui/core/colors/deepPurple';
import green from '@material-ui/core/colors/green';

const rowStyleReception = (record, index, defaultStyle = {}) => {
    if (record && record.recep_user_id === 0 )
        return {
            ...defaultStyle,
            borderLeftColor: deepPurple[400],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };
  

        if (record && record.recep_user_id !== 0)
        return {
            ...defaultStyle,
            borderLeftColor: green[100],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };

        


     
    return defaultStyle;

};

export default rowStyleReception;